import { CheckCircle2 } from "lucide-react";
import UploadErrorsButton from "./UploadErrorsButton";

const TONE = { emerald: "text-emerald-700", indigo: "text-indigo-700" };

// Excel yükleme sonucu: özet satırı + ilk 10 hata (+ dosya verilirse hatalı satırları Excel indirme)
export default function UploadResult({ testid, tone = "emerald", summary, errors, errorLabel = "satır hatalı:", indexedKeys = false, file = null, name = "Yükleme" }) {
  return (
    <div className="space-y-1" data-testid={testid}>
      <div className={`flex items-center gap-1.5 text-xs font-semibold ${TONE[tone]}`}>
        <CheckCircle2 className="w-3.5 h-3.5" /> {summary}
      </div>
      {errors.length > 0 && (
        <div className="bg-red-50 border border-red-200 rounded-md p-2.5 space-y-1">
          <div className="flex items-center gap-2 flex-wrap">
            <div className="text-xs font-semibold text-red-800">{errors.length} {errorLabel}</div>
            <UploadErrorsButton file={file} errors={errors} name={name} testid={`${testid}-errors-xlsx`} className="ml-auto" />
          </div>
          {errors.slice(0, 10).map((er, i) => (
            <div key={indexedKeys ? `${er.row}-${i}` : er.row} className="text-[11px] text-red-700">Satır {er.row}: {er.message}</div>
          ))}
          {errors.length > 10 && <div className="text-[11px] text-red-600">+{errors.length - 10} hata daha — tamamı Excel'de</div>}
        </div>
      )}
    </div>
  );
}
